import React from 'react';
import { RouteId } from "types/frontend_models/navigation/RouteId";
import { FileDoneOutlined, CarOutlined, DesktopOutlined, EuroOutlined, ExperimentOutlined, ReadOutlined } from "@ant-design/icons";
// import { IconName } from "@blueprintjs/core";


export interface ISideBarMenuItem
{
	/** Which route it links to */
	linkRouteId: RouteId,
	/** Possible search to add to the sidebar link */
	search?: string,
	/** On which routes it should be visually marked in the UI */
	activeRouteIds: RouteId[],
	/** The label that shows in the sidebar */
	label: string,
	/** The name of the blueprint icon */
	renderIcon: () => JSX.Element
}

const iconClassName: string = 'aptec-icon';

export const sideBarMenuItems: ISideBarMenuItem[] = [
	{
		linkRouteId: RouteId.home,
		activeRouteIds: [RouteId.home],
		label: 'Home',
		// renderIcon: () => { return <DashboardOutlined className={iconClassName} /> }
		renderIcon: () => { return <DesktopOutlined className={iconClassName} /> }
	},
	{
		linkRouteId: RouteId.libraryDocumentsOveriew,
		activeRouteIds: [
			RouteId.library, RouteId.libraryDocumentsOveriew
		],
		label: 'Library',
		renderIcon: () => { return <ReadOutlined className={iconClassName} /> }
	},
	{
		linkRouteId: RouteId.ordersOverview,
		activeRouteIds: [
			RouteId.orders, RouteId.ordersOverview, RouteId.orderDetail
		],
		label: 'Orders',
		search: encodeURI('sorts=-orderNumber'),
		renderIcon: () => { return <FileDoneOutlined className={iconClassName} /> }
	},
	{
		linkRouteId: RouteId.deliveriesOverview,
		activeRouteIds: [
			RouteId.deliveries, RouteId.deliveriesOverview, RouteId.deliveryDetail
		],
		label: 'Deliveries',
		search: encodeURI('sorts=-id'),
		renderIcon: () => { return <CarOutlined className={iconClassName} /> }
	},
	{
		linkRouteId: RouteId.productsOverview,
		activeRouteIds: [
			RouteId.products, RouteId.productsOverview, RouteId.productDetail
		],
		label: 'Products',
		search: encodeURI('sorts=-keyRef'),
		renderIcon: () => { return <ExperimentOutlined className={iconClassName} /> }
	},
	{
		linkRouteId: RouteId.invoicesOverview,
		activeRouteIds: [
			RouteId.invoices, RouteId.invoicesOverview, RouteId.invoiceDetail
		],
		label: 'Invoices',
		search: encodeURI('sorts=-invoiceDate'),
		renderIcon: () => { return <EuroOutlined className={iconClassName} /> }
	}
];